import * as React from "react";
import {Container,Row, Col} from "reactstrap";
import "./HomeContent.css";

/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class HomeContent extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }  
    render() {
        return (           
            <Container style= {{paddingTop:50}} className = "header-container3">            
                <Row >
                    <Col sm="10" >     
                        <Row>Price List for Party Orders:</Row>
                        <Row className="list-content">Jigarthanda Ice Cream/Scoop - 15 rs.</Row>
                        <Row className="list-content">100 ML above 500 cups - 20 rs.</Row>
                        <Row className="list-content">100 ML below 500 cups - 25 rs.</Row>
                        <Row className="list-content">180 ML above 250 cups - 40 rs.</Row>
                        <Row className="list-content">180 ML below 250 cups - 45 rs.</Row>
                        <Row className="list-content">300 ML above 250 cups - 60 rs.</Row>
                        <Row className="list-content">300 ML below 250 cups - 65 rs.</Row>
                        <Row style= {{paddingTop:30}} className="blink_me">Working hours:  9:30 AM to 09:30 PM</Row>
                    </Col>
                </Row>            
                
            </Container>
        );
    }
}






// WEBPACK FOOTER //
// ./src/components/views/HomeContent.tsx